import { useState, useCallback } from "react"
import { useDioptraFetch } from "./use-dioptra-fetch"
import { getEnv } from "../utils/envManager"
import { authenticateIcertis, IcertisTokens } from "../utils/icertisAuth"

export const useIcertisAuth = () => {
  const [isAuthenticating, setIsAuthenticating] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)
  const { dioptraFetch } = useDioptraFetch()

  const authenticateAndReactivate = useCallback(async (icmBaseUrl: string): Promise<IcertisTokens> => {
    setIsAuthenticating(true)
    setError(null)

    try {
      const tokens = await authenticateIcertis(icmBaseUrl)

      const result = await dioptraFetch(
        `${getEnv("WEBAPP_API_BASE_URL")}/api/user-integrations/icertis`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            icmBaseUrl: icmBaseUrl.trim(),
            authToken: tokens.authToken,
            refreshToken: tokens.refreshToken,
            expiresIn: tokens.expiresIn,
          }),
        }
      )

      if (result.error) {
        throw new Error(result.error + (result.details ? `\n${result.details}` : ""))
      }

      return tokens
    } catch (err) {
      const error = err instanceof Error ? err : new Error("Failed to authenticate and reactivate Icertis integration")
      setError(error)
      throw error
    } finally {
      setIsAuthenticating(false)
    }
  }, [dioptraFetch])

  return {
    authenticateAndReactivate,
    isAuthenticating,
    error,
  }
}

